import React, { useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { TabView, TabPanel } from 'primereact/tabview';
import ChatAssistant from './ChatAssistant';
import './FAQ.css';

const FAQ = () => {
    const [activeTab, setActiveTab] = useState(0);
    
    const faqItems = [
        {
            question: "Vault'u nasıl kullanmaya başlayabilirim?",
            answer: "Vault'u kullanmaya başlamak için öncelikle bir hesap oluşturmanız gerekiyor. Sağ üst köşedeki 'Kayıt Ol' butonuna tıklayarak kolayca hesap oluşturabilirsiniz."
        },
        {
            question: "Şifremi unuttum, ne yapmalıyım?",
            answer: "Giriş sayfasındaki 'Şifremi Unuttum' bağlantısına tıklayarak şifre sıfırlama sürecini başlatabilirsiniz. E-posta adresinize bir sıfırlama bağlantısı gönderilecektir."
        },
        {
            question: "Vault'ta hangi dosya türlerini saklayabilirim?",
            answer: "Vault'ta fotoğraf, video, döküman ve diğer birçok dosya türünü güvenle saklayabilirsiniz. Desteklenen dosya formatları hakkında detaylı bilgi için kullanıcı kılavuzumuza göz atabilirsiniz."
        },
        {
            question: "Dosyalarımın güvenliği nasıl sağlanıyor?",
            answer: "Tüm dosyalarınız endüstri standardı şifreleme yöntemleriyle korunmaktadır. Ayrıca, iki faktörlü kimlik doğrulama gibi ek güvenlik önlemlerini de etkinleştirebilirsiniz."
        },
        {
            question: "Depolama alanımı nasıl artırabilirim?",
            answer: "Hesap ayarlarınızdan premium planlara göz atabilir ve ihtiyacınıza uygun bir depolama planı seçebilirsiniz. Her plan farklı depolama kapasiteleri ve özellikler sunmaktadır."
        }
    ];

    return (
        <div className="help-center">
            <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                <TabPanel header="Sıkça Sorulan Sorular">
                    <div className="faq-container">
                        <Accordion className="faq-accordion">
                            {faqItems.map((item, index) => (
                                <AccordionTab key={index} header={item.question}>
                                    <p>{item.answer}</p>
                                </AccordionTab>
                            ))}
                        </Accordion>
                    </div>
                </TabPanel>
                <TabPanel header="Yardım Asistanı">
                    <ChatAssistant />
                </TabPanel>
            </TabView>

        </div>
    );
};

export default FAQ;
